import { JSX } from 'react';
import { Typography, Grid, Stack } from '@mui/material';

import datatable from '@/json/client-product-shape/data.json';

interface Category {
  name: string; //table category feature name
  description: string; //table feature description
  skills: string[]; //table addtional skills
}

//removed userAnswers and questions and UserAnswer Interface because only really need scores right now

export const generateAnswersTable = (
  pillars: Array<string>,
  scores: number[],
  isMobile: boolean
) => {
  //Stores all of the Table
  const tableItems: Array<any> = [];

  //table header styling pillarGridItemClass & pillarClass to ResultsTableHeader
  const pillarGridItemClass = {
    backgroundColor: '#86BC25',
    padding: '20px',
    border: '1px solid #000000',
  };
  const pillarClass = {
    whiteSpace: 'pre-line',
    fontSize: '1.5rem',
    fontWeight: 'bold',
  };
  // Focus Area  styling
  const focusAreaClasses = [
    { backgroundColor: '#1D1D1D', border: '1px solid #000000' },
    { backgroundColor: '#1D1D1D', border: '1px solid #000000' },
    { backgroundColor: '#1D1D1D', border: '1px solid #000000' },
    { backgroundColor: '#1D1D1D', border: '1px solid #000000' },
  ];

  // Breakdown Chip Levels and styling
  const focusAreaLevels = ['PROFICIENT', 'SKILLED', 'EXPERT'];

  const focusAreaChipClasses = [
    {
      backgroundColor: '#D4D4D4',
      color: '##4F4D4D',
      border: '1px solid #4F4D4D',
    },
    {
      backgroundColor: '#A6C9FF',
      color: '#29508C',
      border: '1px solid #4F4D4D',
    },
    {
      backgroundColor: '#5187DB',
      color: '#001739',
      border: '1px solid #001739',
    },
  ];

  //get hardcoded tableCategories Table Data from data.json
  const categories: Category[] = datatable.tableCategories;

  //Desktop view: check if not mobile
  if (!isMobile) {
    // Create an array for the pillar headers
    const headerItems: Array<JSX.Element> = pillars.map((pillar, index) => (
      <Grid key={`header-${index}`} item xs={3} sx={pillarGridItemClass}>
        <Typography align='center' sx={pillarClass}>
          {pillar}
        </Typography>
      </Grid>
    ));

    tableItems.push(
      //push header item tableitems as single row
      <Grid key='header-row' container>
        {headerItems}
      </Grid>
    );
    // Determine the number of full columns and any remaining items
    const numofFullColumns = Math.ceil(categories.length / 4);

    // Loop through rows // Iterate for the number of categories instead of <4
    for (let i = 0; i < numofFullColumns; i++) {
      const cellsArray = [];

      for (let j = 0; j < 4; j++) {
        //set index of category
        const categoryIndex = i + j * numofFullColumns;
        if (categoryIndex >= categories.length) {
          continue;
        }
        //Get category from index
        const category = categories[categoryIndex];

        const currentFocusArea = categoryIndex + 5;

        //Gets score based on index
        const userScoreValue = scores[categoryIndex];

        // Determine userFocusAreaLevel based on score
        let userFocusAreaLevel = focusAreaLevels[userScoreValue];

        // set chip focus level based on score
        if (userScoreValue <= 1) {
          userFocusAreaLevel = focusAreaLevels[0];
        } else if (userScoreValue > 1 && userScoreValue <= 2) {
          userFocusAreaLevel = focusAreaLevels[1];
        } else if (userScoreValue > 2) {
          userFocusAreaLevel = focusAreaLevels[2];
        }
        //set styling for chips based on focus level of chip
        const focusAreaChipClass =
          focusAreaChipClasses[focusAreaLevels.indexOf(userFocusAreaLevel)];

        const cell = (
          <Grid
            key={`cell-${currentFocusArea}`}
            item
            // Larger screen breakpoints to adjust the grid width
            xs={3}
            sx={{
              padding: '20px',
              ...focusAreaClasses[j],
            }}
          >
            <Stack direction='column' sx={{ alignItems: 'left' }}>
              <Typography
                sx={{
                  ...focusAreaChipClass,
                  fontSize: '0.8rem',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  // Increase size to make the chip larger
                  width: '80px',
                  height: '30px',
                }}
              >
                {userFocusAreaLevel}
              </Typography>
              <Typography
                sx={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  color: '#FFFFFF',
                  marginRight: '10px',
                  marginTop: '10px',
                }}
              >
                {category.name}
              </Typography>
            </Stack>
            <Typography
              sx={{ fontSize: '0.8rem', color: 'white', marginBottom: '10px' }}
            >
              {category.description}
            </Typography>
            <Typography
              sx={{ fontSize: '0.9rem', color: 'white', fontWeight: 'bold' }}
            >
              Additional Skills: <br></br>
            </Typography>

            <ul style={{ fontSize: '0.8rem', color: 'white' }}>
              {category.skills.map((skill, skillIndex) => (
                <li key={`skill-${skillIndex}`}>{skill}</li>
              ))}
            </ul>
          </Grid>
        );
        cellsArray.push(cell);
      }

      // Push the row into the tableItems array
      const row = (
        <Grid key={`row-${i}`} container>
          {cellsArray}
        </Grid>
      );

      tableItems.push(row);
    }
  }
  // Check if it's a mobile screen
  if (isMobile) {
    // Determine the number of full columns and any remaining items

    // Loop through pillars
    for (let i = 0; i < 4; i++) {
      const numofFullColumns = Math.ceil(categories.length / 4);
      const numofRemainingItems = categories.length % 4;

      const header = (
        <Grid key={`header-${i}`} item xs={12} sx={pillarGridItemClass}>
          <Typography align='center' sx={pillarClass}>
            {pillars[i]}
          </Typography>
        </Grid>
      );

      // Create an array for the pillar header and its associated data
      const cellsArray = [header];

      const firstCellIndex = isMobile ? i * 4 : i;

      // Iterate through columns (four columns)
      for (
        let j = 0;
        j < numofFullColumns + (i < numofRemainingItems ? 1 : 0);
        j++
      ) {
        const currentFocusArea = j + firstCellIndex;

        // Calculate the categoryIndex based on the column and index to get 3 items per column
        const categoryIndex = j + i * 3;
        if (categoryIndex >= categories.length) {
          continue;
        }

        const category = categories[categoryIndex];

        // Gets score based on index
        const userScoreValue = scores[categoryIndex];

        // Determine userFocusAreaLevel based on scoreh
        let userFocusAreaLevel = focusAreaLevels[userScoreValue];

        // set chip focus level based on score
        if (userScoreValue <= 1) {
          userFocusAreaLevel = focusAreaLevels[0];
        } else if (userScoreValue > 1 && userScoreValue <= 2) {
          userFocusAreaLevel = focusAreaLevels[1];
        } else if (userScoreValue > 2) {
          userFocusAreaLevel = focusAreaLevels[2];
        }
        //set styling for chips based on focus level of chip
        const focusAreaChipClass =
          focusAreaChipClasses[focusAreaLevels.indexOf(userFocusAreaLevel)];

        const cell = (
          <Grid
            key={`cell-${currentFocusArea}`}
            item
            // Mobile breakpoints to adjust the grid width
            xs={12}
            sx={{
              padding: '20px',
              ...focusAreaClasses[j],
            }}
          >
            <Stack direction='column' sx={{ alignItems: 'left' }}>
              <Typography
                sx={{
                  ...focusAreaChipClass,
                  fontSize: '0.8rem',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  // Increase size to make the chip larger
                  width: '80px',
                  height: '30px',
                }}
              >
                {userFocusAreaLevel}
              </Typography>
              <Typography
                sx={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  color: '#FFFFFF',
                  marginRight: '10px',
                  marginTop: '10px',
                }}
              >
                {category.name}
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.8rem',
                  color: 'white',
                  marginBottom: '10px',
                }}
              >
                {category.description}
              </Typography>
              <Typography
                sx={{ fontSize: '0.9rem', color: 'white', fontWeight: 'bold' }}
              >
                Additional Skills: <br></br>
              </Typography>

              <ul style={{ fontSize: '0.8rem', color: 'white' }}>
                {category.skills.map((skill, skillIndex) => (
                  <li key={`skill-${skillIndex}`}>{skill}</li>
                ))}
              </ul>
            </Stack>
          </Grid>
        );
        cellsArray.push(cell);
      }

      // Push the row into the tableItems array
      const row = (
        <Grid key={`row-${i}`} container>
          {cellsArray}
        </Grid>
      );

      tableItems.push(row);
    }
  }

  return tableItems;
};
